import {Project} from '../models/project.model';

export class ProjectsState {
  items: Project[];
}
